import { parse as e } from "./parser.js";
import { TextRun as t } from "./TextRun.js";
import * as n from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/FormattedText.tsx
var i = n.memo((i) => {
	let a = i.children;
	if (!a) return null;
	let o = n.useMemo(() => e(a), [a]);
	return /* @__PURE__ */ r("span", {
		className: i.className,
		children: /* @__PURE__ */ r(t, { content: o })
	});
});
i.displayName = "FormattedText";
//#endregion
export { i as FormattedText };
